import { Field, Formik, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { useState } from 'react';
import useAxios from '../../hooks/useAxios';
import Constants from '../../Constants';
import { confirm } from '../../utils/swal';
import XLink from '../../components/common/XLink';
import XButton from '../../components/common/XButton';
import {
    inputFieldClasses,
    inputFieldStyleClasses,
    labelStyleClasses,
    errorMessageClasses,
} from '../../components/common/formInputClasses';

const successSectionClasses = 'text-center bg-surface';
const successHeadingClasses = 'text-[calc(var(--spacing)*25)] font-bold text-primary mb-0 [text-shadow:3px_5px_2px_color-mix(in_srgb,var(--color-content)_20%,transparent)]';
const successSubheadingClasses = 'block text-2xl text-content font-semibold mt-5 [text-shadow:none]';
const successParagraphClasses = 'px-4 pt-2.5 pb-5';
const ForgotPassword = () => {
    const { postData } = useAxios()
    const [emaiSentSuccessfully , setemaiSentSuccessfully] = useState(0)
    const validationSchema = Yup.object().shape({
        email: Yup.string().required('Email is required').email('Please enter a valid email'),
    })
    const onSubmit = (values) => {
        postData(Constants.ApiUrl.auth.forgotPassword, values).then((res) => {
            if(res.success){
                setemaiSentSuccessfully(1)
            }else{
                confirm({ icon: "error", title: res.message });
            }
        }).catch(err => {
            confirm({ icon: "error", title: err.message });
        })
    }
    return ( 
        <>
        {
            emaiSentSuccessfully === 0 ? 
            <div className="content">
                <h3 className="font-['Open_Sans',serif]! text-content mb-6!">
                    Forgot Password
                </h3>
                <Formik
                    initialValues={{
                        email: '',
                    }}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setErrors }) => {
                        onSubmit(values, setErrors)
                    }}
                >
                    {() => (
                        <Form>
                            <div className="fields">
                                <div className="form-group">
                                    <label className={labelStyleClasses}>Email</label>
                                    <div className={inputFieldClasses}>
                                        <Field className={inputFieldStyleClasses} name="email" placeholder="Email" />
                                        <ErrorMessage name="email" component="div" className={errorMessageClasses} />
                                    </div>
                                </div>
                            </div>
                            <div className='flex justify-between items-center'>
                                <XLink to="/account/login"><i className="fa-solid fa-arrow-left"></i> Back to Login</XLink>
                                <XButton type="submit">Submit</XButton>
                           </div>
                        </Form>)}
                </Formik>
        </div>
        :
        <section className={`section ${successSectionClasses}`}>
            <div className="inline-block">
                <h1 className={successHeadingClasses}>
                    <i className="fa fa-envelope"></i>
                    <span className={successSubheadingClasses}>Email sent Successfully!</span>
                </h1>
                <p className={successParagraphClasses}>Please check your mail</p>
                <XLink to="/account/login"><i className="fa-solid fa-arrow-left"></i> Back to Login</XLink>
            </div>
        </section>
        }
        </>

    )
}

export default ForgotPassword;